import React, { Fragment } from "react";
import moment from "moment";
import Flatpickr from "react-flatpickr";

import { Czech } from "flatpickr/dist/l10n/cs.js";
import "flatpickr/dist/themes/light.css";

import "../../assets/scss/plugins/forms/flatpickr/flatpickr.scss";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

class DateTime extends React.Component {
  flatpickrRef = null;

  state = {
    id: this.props.id ? this.props.id : "date-time-" + makeid(16),
    className: this.props.className ? this.props.className : "",
    defaultValue: this.props.defaultValue ? this.props.defaultValue : null,
    allowInput: this.props.allowInput ? this.props.allowInput : true,
    name: this.props.name ? this.props.name : "",
    style: this.props.style ? this.props.style : {},
    value: this.props.value ? this.props.value : null,
    options: this.props.options ? this.props.options : {},
  };

  componentDidMount() {}

  componentDidUpdate(prevProps, nextProps) {
    if (this.props.value !== prevProps.value)
      this.setState({ value: this.props.value });
  }

  handleOnChange = async (date) => {
    if (!Array.isArray(date)) date = [date];

    let tmp = [];

    if (date.length !== 0) {
      tmp.push(moment(date[0]).format("YYYY-MM-DDTHH:mm:ss"));

      if (date[1]) tmp.push(moment(date[1]).format("YYYY-MM-DDTHH:mm:ss"));
    }

    if (this.props.onChange) this.props.onChange(tmp);
  };

  open = () => {
    if (this.flatpickrRef) this.flatpickrRef.flatpickr.open();
  };

  clear = () => {
    if (this.flatpickrRef?.flatpickr) {
      this.flatpickrRef.flatpickr.clear();
    }

    this.setState({
      value: null,
    });

    if (this.props.onChange) {
      this.props.onChange([]);
    }

    if (this.props.onClear) {
      this.props.onClear();
    }
  };

  render() {
    let options = {
      ...this.state.options,
      locale: {
        ...moment.locale() === "cs" ? Czech : {},
        rangeSeparator: " - ",
      },
    };

    if (this.props.disabled && this.state.value && this.props.displayInline) {
      return <span className="font-weight-bold">{this.state.value}</span>;
    }

    const hasValue =
      this.state.value !== null &&
      this.state.value !== undefined &&
      this.state.value !== "";

    return (
      <div
        className={
          !!this.props.disabled
            ? "disabled-flatpickr-wrapper"
            : ""
        }
        style={{
          position: "relative",
        }}
      >
        <Flatpickr
          ref={(ref) => (this.flatpickrRef = ref)}
          id={this.state.id}
          className={this.state.className}
          style={{
            ...this.state.style,
            display: this.props.hideInput ? "none" : undefined,
            paddingRight:
              this.props.clearable && hasValue
                ? "35px"
                : this.state.style?.paddingRight,
          }}
          name={this.state.name}
          allowInput={this.state.allowInput}
          disabled={!!this.props.disabled}
          defaultValue={this.state.defaultValue}
          value={this.state.value}
          onChange={(date) => this.handleOnChange(date)}
          options={options}
        />

        {this.props.clearable &&
          hasValue &&
          !this.props.disabled && (
            <button
              type="button"
              aria-label="Vymazat datum"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                this.clear();
              }}
              style={{
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                padding: 0,
                border: 0,
                background: "transparent",
                cursor: "pointer",
                fontSize: "24px",
                lineHeight: 1,
                color: "#626262",
                zIndex: 2,
              }}
            >
              ×
            </button>
          )}
      </div>
    );
  }
}

DateTime.defaultProps = {
  displayInline: true,
};

export default DateTime;
